import { InboxMessage } from './inboxMessage';
export interface Filter {
  ValueFrom: string;
  ValueTo: string;
  singleValue: string;
  filterType: filterTypes;
}

export interface InboxParams {
  page: number;
  pageSize: number;
  sortByField: string;
  sortByDir: string;
  term: string;
  filters: { [key: string]: Filter };
}

export enum filterTypes {
  Number = 1,
  Date = 2,
  String = 4,
}

export interface InboxResponse {
  data: InboxMessage[];
  recordsFiltered: number;
  recordsTotal: number;
}
